import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import BorrowerBinder from "./BorrowerBinder";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TKEY = "th_broker_token";

// Broker-side read-only preview of a client's Electronic Pre-Closing Binder.
export default function BrokerBinder() {
  const { appId } = useParams();
  const navigate = useNavigate();
  const [app, setApp] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const token = localStorage.getItem(TKEY);
    if (!token) { setError("Please sign in to your broker account first."); return; }
    axios.get(`${API}/broker/clients/${appId}`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setApp(r.data.application))
      .catch((e) => setError(e?.response?.data?.detail || "Unable to load this client's binder."));
  }, [appId]);

  if (error) {
    return (
      <div className="min-h-screen bg-[#1a1a14] text-[#ECECE4] flex items-center justify-center p-8" data-testid="broker-binder-error">
        <div className="text-center">
          <div className="text-[#FF8585] mb-3">{error}</div>
          <button onClick={() => navigate("/broker")} className="text-[#B8860B] text-sm underline">← Back to broker portal</button>
        </div>
      </div>
    );
  }
  if (!app) {
    return <div className="min-h-screen bg-[#1a1a14] text-[#ECECE4] flex items-center justify-center" data-testid="broker-binder-loading"><Loader2 className="animate-spin" /></div>;
  }
  return (
    <BorrowerBinder
      binder={app.binder}
      signatures={app.signatures || []}
      titleAccepted={!!app.title_accepted}
      onBack={() => navigate("/broker")}
    />
  );
}
